<template>
  <div >
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
      @clearAll="onSearch"
    />
    <el-button type="primary" class="mb20" @click="create">新建</el-button>
    <!-- <Table
      ref="table"
      :table-data="tableData"
      @getData="getList"
      @changeSelection="changeTableSelection"
    >
      <el-table-column slot="action" align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetail(scope.row)">停用</el-button>
          <el-button type="text" @click="showDetail(scope.row)">编辑</el-button>
          <el-button type="text" @click="showDetail(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </Table> -->
    <c-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="searchParams"
        :tabIndexPageReset='true'
        :pager="true"
        :api="getInternalTrainingList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-name="scope">
          <p v-html="scope.row.name"></p>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-isAdjunct="scope">
          {{ scope.row.isAdjunct === 1 ? '是' : '否' }}
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.status === 1 ? '已启用' : '已停用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 2 ? '启用' : '停用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.status === 2"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </c-table>
    
    <Handle ref='dialog' :editParams='editParams' @success='success'></Handle>
  </div>
</template>

<script>
// import Table from "@/components/Table/index";
import CTable from '@/components/PublicTable';
import DirectRecordSearch from "@/components/Search/index";
import Handle from "./handle.vue";
import { getInternalTrainingList,trainUpdateState,deleteTrain } from '@/api/api'
export default {
  components: {
    // Table,
    CTable,
    DirectRecordSearch,
    Handle
  },
  data() {
    return {
      getInternalTrainingList,
      trainUpdateState,
      deleteTrain,
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          // { label: '排序号', value: 'id' },
          { label: '内训标题', value: 'name', type: 'slot'},
          { label: '是否包含附件', value: 'isAdjunct', type: 'slot' },
          { label: '状态', value: 'state', type: 'slot' },
          { label: '操作人', value: 'insertName' }
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true },
            { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            { label: '编辑', type: 'text', event: 'edit', show: true },
          ]
        }
      },
      searchOptions: [
        {
          type: "input",
          label: "内训标题",
          prop: "name",
          width: "230px",
          placeholder: "请输入内训标题",
        },
      ],
      searchParams: {
        name:null
      },
      editParams:{}
    };
  },
  mounted(){
    this.getList();
  },
  methods: {
    create(){
      this.editParams={};
      this.$refs.dialog.setOpacity(true)
    },
    success(){
      this.editParams={};
      this.getList()
    },
     // 通过随机数请求列表
    getList(params) {
      this.searchParams = params;
      this.tableInfo.refresh = Math.random();
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    handleClick(event,row){
      console.log(row)
      if (event === 'edit') {
        this.create();
        this.editParams = JSON.parse(JSON.stringify(row));
        // this.$refs.cooperatorDialog.init(row);
        // this.dialogVisible = true;
      } else if (event === 'state') {
        trainUpdateState({
          id: row.id,
          status:row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 1 ? '操作成功' : '操作成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTrain({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // 查询
    onSearch(data) {
        console.log(data)
    },
   
    // 切换选择
    changeTableSelection(val) {
      console.log(val);
    },
    // 操作
    showDetail(row) {
      console.log(row);
    },
    getAcceptBankLevelType(){

    }
  },
};
</script>
<style lang='scss' scoped>
.mb20{
  margin-bottom: 20px;
}
</style>